import { render, staticRenderFns } from "./HowToCarousel.vue?vue&type=template&id=317358a2"
import script from "./HowToCarousel.vue?vue&type=script&lang=js"
export * from "./HowToCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports